import type { Resource } from '../../';
export const general_logoAlt: Resource = {"default":"Deckers Brands Logo"};
